import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { OnboardingChapterModule } from '@app/+onboarding/chapters/components/chapter.module';
import { TranslatePipe } from '@ngx-translate/core';
import { MapMarker, MapPlace, MapsComponent, MapsService } from '@sb/maps';
import { SbFormFieldComponent } from '@sb/ui/form-field';
import { InputDirective } from '@sb/ui/input';
import { filter, take } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'time-tracking-clocking-location',
  imports: [
    OnboardingChapterModule,
    TranslatePipe,
    SbFormFieldComponent,
    ReactiveFormsModule,
    InputDirective,
    MapsComponent,
  ],
  templateUrl: './time-tracking-clocking-location.component.html',
})
export class TimeTrackingClockingLocationComponent implements OnInit {
  private ngZone = inject(NgZone);
  private mapsService = inject(MapsService);

  selectedLocationMarker: MapMarker;

  @Input()
  nextButtonLoading: boolean;

  @Input()
  skipButtonLoading: boolean;

  @Output()
  next = new EventEmitter<void>();

  @Output()
  skip = new EventEmitter<void>();

  @Output()
  locationChange = new EventEmitter<MapPlace>();

  @ViewChild('addressInput', { static: true })
  addressInput!: ElementRef<HTMLInputElement>;

  onNext() {
    if (this.selectedLocationMarker) {
      this.next.emit();
    }
  }

  ngOnInit() {
    void this.mapsService.apiLoaded$
      .pipe(
        filter((loaded) => loaded),
        take(1),
      )
      .subscribe(() => this.setupAutocomplete());
  }

  private setupAutocomplete() {
    const autocomplete = this.mapsService.getAutocomplete(this.addressInput.nativeElement);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place = autocomplete.getPlace();

        if (!place?.geometry?.location) {
          return;
        }

        this.selectedLocationMarker = {
          id: place.name || 'main-location',
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        this.locationChange.emit(place);
      });
    });
  }
}
